import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { InfoIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NonHubSpotStatus = () => /*#__PURE__*/_jsx(UIFlex, {
  children: /*#__PURE__*/_jsxs(UIButton, {
    use: "link",
    children: [/*#__PURE__*/_jsx(InfoIcon, {
      "aria-label": "Non-HubSpot Forms"
    }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.nonHubSpotForms.title"
    })]
  })
});
export default NonHubSpotStatus;